import { SUBMISSION_TYPES } from 'constants/submissionTypes';

const template = (option, row, userName, userInfo = {}) => {
  const { AdminAccessToClientsList, IsInternalUser, IsSuperUser } = userInfo;
  const hasAdminAccessTo = AdminAccessToClientsList
    ? AdminAccessToClientsList.map((client) => client.ClientNumber)
    : [];
  const hasAdminAccessToCurrentRow =
    IsInternalUser ||
    (!IsInternalUser && hasAdminAccessTo.includes(row.ClientNumber));
  const isCreatedByUser = row.CreatedByName === userName;

  if (['edit'].includes(option.code)) {
    //! Added the (|| hasAdminAccessToCurrentRow) condition to allow admins on a specific client number
    //! to edit locked templates that they have admin access to.
    //! Double check if only the same user should be able to edit.
    return !row.LockTemplate || isCreatedByUser || hasAdminAccessToCurrentRow;
  }

  if (['delete'].includes(option.code)) {
    // const isLocked = row.LockTemplate;
    // const isAdmin = hasAdminAccessToCurrentRow;
    //! Previous condition before implementing the Admin roles related to a specific client number.
    // return (!isCreatedByUser && isLocked && isAdmin) || isCreatedByUser;
    return (!isCreatedByUser && hasAdminAccessToCurrentRow) || isCreatedByUser;
  }

  if (['multiDelete'].includes(option.code)) {
    // const isLocked = row.LockTemplate;
    const isCreatedByUser = row.CreatedByName === userName;
    // const isAdmin = hasAdminAccessToCurrentRow;
    return (!isCreatedByUser && hasAdminAccessToCurrentRow) || isCreatedByUser;
  }

  if (['excel'].includes(option.code)) {
    return (
      !row.HasCompositeSamples &&
      row.SubmissionTypeId !== SUBMISSION_TYPES.FOOD_SL
    );
  }

  return [
    'edit',
    'copy',
    'share',
    'newSubmission',
    'newOrder',
    'excel',
    'multiDelete',
    'delete',
  ].includes(option.code);
};

const order = (option, row) => {
  /*
    -1  == submitted
    -2  == draft
    0   == OnHold || Deleted
    6   == Cancelled
  */

  if (['0', '8'].includes(row.Status)) return false; // OnHold or Deleted

  if (row.Status === '-2') {
    // Draft
    return [
      'edit',
      'copy',
      'newTemplate',
      'newSubmission',
      'share',
      // 'cancel',
      'multiDelete',
      'delete',
    ].includes(option.code);
  } else if (row.Status === '6') {
    // Cancelled
    return [
      'view',
      'copy',
      'newTemplate',
      'newSubmission',
      'share',
      'multiDelete',
      'delete',
    ].includes(option.code);
  }

  return ['view', 'copy', 'newTemplate', 'newSubmission', 'share'].includes(
    option.code,
  );
};

const job = (option, row) => {
//validate status with prepaid
   if(row.IsPrepaidJob && (row.MaxxamJobNumber || '') === '')
   {
     if (row.RequestStatus === 'D' && !row.IsInternalUser) {
       return ['newOrder', 'share', 'multiDelete', 'delete'].includes(
         option.code,
       );
     }  
       else if (row.RequestStatus === 'D') {  
          return ['edit', 'newOrder', 'share', 'multiDelete', 'delete'].includes(
            option.code,
          );
        } else if (row.RequestStatus === 'E') {  
          return [ 'view', 'newOrder', 'newSubmission', 'cancel', 'request', 'paynow'].includes(
            option.code,
          );
     } else if (row.RequestStatus === 'P' && row.Status === 'R') {
       return ['view', 'newOrder', 'newSubmission', 'receipt'].includes(
         option.code,
       );
     } else if (row.RequestStatus === 'O' && (row.Status === 'C' || row.Status ==='E')) {
       return ['edit','multiDelete', 'delete'].includes(
         option.code,
       );
     } else if (row.RequestStatus === 'O' && row.Status === 'S') {
       return ['edit', 'newSubmission', 'newOrder', 'share', 'cancel'].includes(
         option.code,
       );
     } else if (row.RequestStatus === 'P') {  
          return ['view', 'share', 'newOrder', 'newSubmission','receipt'].includes(
              option.code,
            );
        } else if (row.RequestStatus === 'C') {  
          return [ 'view', 'newOrder', 'newSubmission', 'multiDelete', 'delete'].includes(
            option.code,
          );
        } 
   }
   else
  {   //validate status with job
        if (row.Status === 'D') {
          return ['edit', 'newOrder', 'share', 'multiDelete', 'delete'].includes(
          option.code,
          );
        } else if (row.Status === 'S' && row.IsPrepaidJob) {
          return ['view','newSubmission', 'newOrder', 'share', 'cancel','receipt'].includes(
            option.code,
          );
        } else if (row.Status === 'S') {
          return ['edit', 'newSubmission', 'newOrder', 'share', 'cancel'].includes(
            option.code,
          );
        } else if (row.Status === 'E') {
          return ['edit', 'newOrder', 'share'].includes(option.code);
        } else if (row.Status === 'C') {
          return ['edit', 'multiDelete', 'delete'].includes(option.code);
        } else if (row.Status === '2' && row.IsPrepaidJob) {
          return ['view'].includes(option.code);
        } else if (['R', '0', '1', '5'].includes(row.Status)) {
          if (
            option.code === 'addTest' &&
            row.MaxxamJobNumber !== null &&
            row.UserLOB !== 'F' &&
            row.IsInternalUser &&
            !row.IsPrepaidJob
          ) {
            return true;
          }
          if (row.IsPrepaidJob) {
            return [
              'view',
              'newSubmission',
              'newOrder',
              'receipt',
            ].includes(option.code);
          }
          return [
            'view',
            'newTemplate',
            'newSubmission',
            'newOrder',
            'share',
          ].includes(option.code);
        }
  }
  return false;
};

const invoice = (option, row) => {
  if (option.code === 'view') return true;
  if (option.code === 'pay')
    return row.AmountRemaining > 0 && Number(row.IsPayable) === 1;
  return false;
};

const sample = (option) => {
  if (option.code === 'view') return true;
  return false;
};

const customReport = (option, row) => {
  if (row.Status === 1 || row.Status === 2) return false;
  if (option.code === 'edit') return true;
  if (option.code === 'copy') return true;
  if (option.code === 'delete') return true;
  if (option.code === 'download') return row.ProgressMessage === 'Completed';
  return false;
};

const additionTab = (option, row) => {
  if (option.code === 'edit') {
    return ['C', 'E', 'S', 'D'].includes(row.Status);
  }
  if (option.code === 'cancel') {
    if (row.Status === 'S') {
      return true;
    }
  }

  if (option.code === 'delete') {
    return ['C', 'D'].includes(row.Status);
  }

  if (option.code === 'multiDelete') {
    return ['C', 'D'].includes(row.Status);
  }

  if (option.code === 'view') {
    if (row.Status === 'R') {
      return true;
    }
  }

  if (option.code === 'share') {
    return !['C'].includes(row.Status);
  }

  return false;
};

const splitReport = (option, row) => {
  if (option.code === 'edit') {
    return ['D'].includes(row.Status);
  }

  if (option.code === 'delete') {
    return ['D'].includes(row.Status);
  }

  // ! Please keep this commented code for future reference to implement the massDelete feature in case requested in the future for split Report tab.
  // if (option.code === 'multiDelete') {
  //   return ['D'].includes(row.Status);
  // }

  if (option.code === 'download') {
    if (row.Status === 'C') {
      return true;
    }
  }

  return false;
};



export default {
  template,
  job,
  order,
  invoice,
  customReport,
  sample,
  additionTab,
  splitReport,
};



// WEBPACK FOOTER //
// ./src/helpers/rowRules.js